export default "__VITE_ASSET__Dvx9CHHs__"